import style from "./style.module.sass";
import React from "react";
import {useTheme} from "@material-ui/core/styles";
import NewsMultilang from "../../../../multilang-components/News";
import {useTranslation} from "react-i18next";

export default function  News () {
    const {theme: {bgColors, colors}} = useTheme();
    const {t} = useTranslation();
    return (
        <div style={{backgroundColor: bgColors.bgPrimary0}} className={`${style.news}`} title={t('accessibility_analysis_news-channel')}>
            <h1 style={{color: colors.colorMutedText}} className={`${style.textNewsTitle}`}>&nbsp;  {t("Textlab-News")}</h1>
            <NewsMultilang/>
        </div>
    )

}